import React from 'react';
import { Box } from '@mui/material';

import { getInitials } from '../../../lib/helpers/avatar';
import { DS } from '../designTokens';

const Avatar = ({ name }: { name: string }) => (
  <Box
    sx={{
      position: 'relative',
      width: 112,
      height: 112,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mx: 'auto',
      mb: 1.5,
    }}
  >
    <Box
      sx={{
        width: 96,
        height: 96,
        borderRadius: '50%',
        bgcolor: DS.surfaceTint,
        color: DS.softBlack,
        display: 'grid',
        placeItems: 'center',
        fontFamily: DS.fontDisplay,
        fontWeight: 600,
        fontSize: 32,
      }}
    >
      {getInitials(name)}
    </Box>
  </Box>
);

export default Avatar;
